import ColorTools from '@/mainMenuSrc/api/colorTools.js'
import SizeTools from '@/mainMenuSrc/api/sizeSettingsTools'

export default class UserSettings {
  
  static GetAllSettingsVariable(userSettings) {
    let result =  ColorTools.getAllShadesColorSettings(userSettings.mainColor)
    result['--accentColor'] = `rgb(${userSettings.accentColor})`
    result['--accentColorValue'] = userSettings.accentColor
    SizeTools.addAllSizeSettings(result, userSettings.userSizeSettingsString, userSettings.defaultSizeSettingsString)
    return result
  }
}